/**
 *
 * Using the reserveStatus from CMS return an object with boolean statuses of what elements should be displayed
 */

import { InventoryStatus, ReserveStatus } from '../../types';

interface Props {
  reserveStatus: ReserveStatus;
  inventoryStatus: InventoryStatus;
}

const getPhoneInventoryVisibility = ({
  reserveStatus,
}: Props): boolean => {
  switch (reserveStatus) {
    case ReserveStatus.ChatWithMobilist:
      return false;
    case ReserveStatus.Always:
      return true;
    case ReserveStatus.InventoryBased:
      // Inventory based
      return true;
    default:
      return false;
  }
};

export default getPhoneInventoryVisibility;
